// @ts-ignore
document.addEventListener('DOMContentLoaded', () => {
    const desktopLinks = document.querySelector('[data-js-links-bar]');
    const mobileLinks = document.querySelector('[data-js-links-bar-mobile]');
    const mobileModal = document.querySelector('[data-js-links-bar-modal]');
    const closeModalButton = document.querySelector('[data-js-close-button]');
    const copyButton = document.querySelector('[data-js-copy-clipboard]');
    // @ts-ignore
    const copyTargetSelector = copyButton?.getAttribute('data-js-copy-clipboard');
    // @ts-ignore
    const copyTarget = document.querySelector(copyTargetSelector);

    const newModalBackdrop = document.createElement('div');

    newModalBackdrop.className = 'modal__backdrop modal_in';

    // Display mobile/desktop
    const isWindowWidthLargerOrEqual = () => window.innerWidth >= 1024;

    const addClassIfWindowWidthLargerOrEqual = () => {
        const viewportHeight = document.getElementsByTagName('html')[0].getBoundingClientRect().height;
        const scrollHeight = window.scrollY;

        if (scrollHeight >= viewportHeight / 2) {
            if (isWindowWidthLargerOrEqual()) {
                desktopLinks?.classList.add('share-buttons_shown');
            } else {
                mobileLinks?.classList.add('share-buttons_shown');
            }

            // Remove the event listener after the class is added
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            window.removeEventListener('scroll', handleScroll);
        }
    };

    const handleScroll = () => {
        addClassIfWindowWidthLargerOrEqual();
    };

    window.addEventListener('scroll', handleScroll);

    // Run the function initially in case the user has already scrolled down
    addClassIfWindowWidthLargerOrEqual();

    const addModalBackdrop = () => {
        // @ts-ignore
        mobileLinks?.parentNode?.insertBefore(newModalBackdrop, mobileModal?.nextSibling);
    };

    const removeModalBackdrop = () => {
        const modalBackdrop = document.querySelector('.modal__backdrop');

        if (modalBackdrop) {
            modalBackdrop.remove();
        }
    };

    addClassIfWindowWidthLargerOrEqual();

    window.addEventListener('resize', () => {
        addClassIfWindowWidthLargerOrEqual();
    });

    // Open Modal when mobile links element clicked
    mobileLinks?.addEventListener('click', () => {
        mobileModal?.classList.add('share-buttons__modal');
        addModalBackdrop();
    });

    closeModalButton?.addEventListener('click', () => {
        mobileModal?.classList.remove('share-buttons__modal');
        removeModalBackdrop();
    });

    copyButton?.addEventListener('click', async () => {
        try {
            // @ts-ignore
            await navigator.clipboard.writeText(copyTarget?.value);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Failed to copy: ', err);
        }
    });
});
